import React from "react";
import { Alert, Progress, Space, Typography } from "antd";

const { Text } = Typography;

interface TaskProgressProps {
  total?: number;
  current?: number;
  status?: "init" | "running" | "success" | "error" | "stopped" | "completed";
  title?: string;
  description?: string;
}

const TaskProgress: React.FC<TaskProgressProps> = ({
  total = 0,
  current = 0,
  status = "init",
  title = "任务进度",
  description,
}) => {
  const percent = total > 0 ? Math.min(100, Math.round((current / total) * 100)) : 0;
  const progressStatus = status === "error" ? "exception" : status === "success" || status === "completed" ? "success" : "active";

  return (
    <Alert
      type={status === "error" ? "error" : "info"}
      showIcon
      message={title}
      description={
        <Space direction="vertical" style={{ width: "100%" }}>
          {description && <Text type="secondary">{description}</Text>}
          <Progress percent={percent} status={progressStatus} />
          <Text type="secondary">
            {current}/{total || "-"} · {status}
          </Text>
        </Space>
      }
    />
  );
};

export default TaskProgress;
